import { ContentsTableData, Heading } from '../../hooks/useContentsTable'
import styles from '../../styles/_table.module.scss'

type Props = {
  data: ContentsTableData
  onClick?: (heading: Heading) => void | Promise<void>
}

export const ContentsTable = ({
  data: { headings, activeIndex },
  onClick: handleClick = (heading) => heading.scroll(),
}: Props) => {
  if (!headings) return <></>
  return (
    <div className={styles.tableContents}>
      <ol>
        {headings.map((heading, index) => (
          <li
            key={index}
            className={`${styles[heading.type]} ${
              activeIndex === index ? styles.active : ''
            }`}
            onClick={async () => {
              await handleClick(heading)
            }}
            dangerouslySetInnerHTML={{
              __html: heading.text,
            }}
          />
        ))}
      </ol>
    </div>
  )
}
